import {cn} from '@sollapay/ui/lib';

import {isPackageReadOnly} from '../utils';
import {ActivationPackageRow} from './ActivationPackageRow';

import type {ActivationPackageConfig} from '../config';
import type {ActivationPackageViewModel} from '../hooks';
import type {PackageType} from '@sollapay/enums';
import type {FC} from 'react';

interface ActivationPackageListProps {
  packages: ActivationPackageViewModel[];
  packageConfig: Record<PackageType, ActivationPackageConfig>;
  onPackageNavigate: (type: PackageType) => void;
  isActivationLocked?: boolean;
  isViewOnly?: boolean;
  className?: string;
}

export const ActivationPackageList: FC<ActivationPackageListProps> = ({
  packages,
  onPackageNavigate,
  isActivationLocked = false,
  isViewOnly = false,
  className = ''
}) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 pt-12',
        isActivationLocked || isViewOnly ? 'pb-6' : 'pb-32',
        className
      )}
      data-slot="activation-package-list"
    >
      {packages.map(pkg => (
        <ActivationPackageRow
          key={pkg.type}
          type={pkg.type}
          status={pkg.status}
          canEdit={pkg.canEdit}
          canSubmit={pkg.canSubmit}
          readiness={pkg.readiness}
          onNavigate={() => onPackageNavigate(pkg.type)}
          isReadOnly={isPackageReadOnly(pkg, {isActivationLocked, isViewOnly})}
        />
      ))}
    </div>
  );
};
